goog.provide('el8.tourguide.util');

el8.tourguide.util = (function() {

    return {
        manageSplash: function(opts) {
            opts = opts || {};
            var $splash = $('#tourguide-splash');
            $('.start-trigger', $splash).removeClass('imageLoading');
            if (opts.startBtnFn) {
                $('.start-trigger', $splash).html(opts.startBtnFn());
            }
            if (opts.startTriggerFn) {
                $splash.on('click', '.start-trigger',  function(e) {
                    $splash.remove();
                    opts.startTriggerFn();
                });
            }
        }
    };

})();
